var messageStatuses = [
    {"name": "پیام جدید", id: 0},
    {"name": "خوانده شده", id: 1},
];

export default messageStatuses;